var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon20Socicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00003 17.4695V3.9509L0.635002 1.07236C0.229001 0.872694 0 1.12619 0 1.34935V14.7173L6.28302 17.9619C6.58603 18.1106 7.00003 17.7994 7.00003 17.4695ZM19.8562 4.13678L13.5192 1.03901C13.4162 0.985174 13.2852 1.0253 13.2232 1.12024L9.56017 6.94778L13.9192 13.8794L19.9172 4.34526C19.9662 4.27087 19.9312 4.17691 19.8562 4.13678ZM8 12.2038L13.333 14.8161L8 6.33319V12.2038ZM19.45 17.7993L14.232 15.2486L20 6.08056V17.4626C20 17.7993 19.752 17.948 19.45 17.7993Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20Socicon);
export default __webpack_public_path__ + "static/media/icon--20-socicon.4b961a41.svg";
export { ForwardRef as ReactComponent };